export default {
    path: '/reports/therapyrooms-hipaa',
    component: () =>
      import('@/views/general-reports/therapyrooms-hipaa/Wrapper.vue'),
    children: [
      {
        path: '',
        name: 'therapyrooms-hipaa',
        component: () =>
          import('@/views/general-reports/therapyrooms-hipaa/Main.vue'),
      },
    ],
  }